import {
  Box,
  Modal,
  Typography,
  Button,
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { FilesService } from "../filesService/FilesService";
import { UrlApi } from "../../../services/apirest";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  width: "100%",
  maxWidth: 550,
  textAlign: "center",
};

const OdsModal = ({ open, onClose, year }) => {
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);

  // Cargar datos
  useEffect(() => {
    if (!open) return;
    if (employees.length > 0 && branches.length > 0) return;

    const fetchData = async () => {
      try {
        setLoadingData(true);
        const [empRes, branchRes] = await Promise.all([
          fetch(`${UrlApi}/empleados`),
          fetch(`${UrlApi}/sucursales/escencial`),
        ]);
        const empData = await empRes.json();
        const branchData = await branchRes.json();
        setEmployees(Array.isArray(empData) ? empData : []);
        setBranches(Array.isArray(branchData) ? branchData : []);
      } catch (err) {
        console.error("Error cargando empleados/sucursales:", err);
      } finally {
        setLoadingData(false);
      }
    };

    fetchData();
  }, [open]);

  // Exclusión mutua: si elige empleados, borra sucursales y viceversa
  useEffect(() => {
    if (selectedEmployees.length > 0) setSelectedBranches([]);
  }, [selectedEmployees]);

  useEffect(() => {
    if (selectedBranches.length > 0) setSelectedEmployees([]);
  }, [selectedBranches]);

  // Generar CSV
  const handleGenerate = async () => {
    setLoading(true);
    try {
      const filters = {
        employeeIds: selectedEmployees.map((e) => e.legajo),
        branchIds: selectedBranches.map((b) => b.id),
      };

      await FilesService.downloadAnnualCsv(year, filters);
      onClose();
    } catch (err) {
      console.error("Error generando CSV:", err);
      alert(
        `Error al generar el archivo CSV.\n${
          err.response?.statusText || err.message
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  const isDisabledButton =
    selectedBranches.length === 0 && selectedEmployees.length === 0;

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
          Generar Reporte CSV {year}
        </Typography>

        {loadingData ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography variant="body2" sx={{ mb: 3, color: "text.secondary" }}>
              Seleccioná empleados o sucursales para filtrar el reporte.
            </Typography>

            <Autocomplete
              multiple
              size="small"
              options={employees}
              getOptionLabel={(e) => `${e.nombreApellido} (Legajo ${e.legajo})`}
              value={selectedEmployees}
              onChange={(_, value) => setSelectedEmployees(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Empleados"
                  placeholder="Buscar..."
                />
              )}
              disabled={selectedBranches.length > 0}
              sx={{ mb: 2 }}
            />

            <Autocomplete
              multiple
              size="small"
              options={branches}
              getOptionLabel={(b) => `${b.nombre} (ID ${b.id})`}
              value={selectedBranches}
              onChange={(_, value) => setSelectedBranches(value)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sucursales"
                  placeholder="Buscar..."
                />
              )}
              disabled={selectedEmployees.length > 0}
              sx={{ mb: 3 }}
            />

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
              <Button variant="outlined" onClick={onClose}>
                Cancelar
              </Button>
              <Button
                variant="contained"
                color="success"
                onClick={handleGenerate}
                disabled={isDisabledButton || loading}
              >
                {isDisabledButton ? (
                  "Selecciona un empleado o sucursal"
                ) : loading ? (
                  <CircularProgress size={22} sx={{ color: "white" }} />
                ) : (
                  "Generar CSV"
                )}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default OdsModal;
